import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    width: '100%',
    margin: `2em`,
    display: 'flex',
    justifyContent: 'center',
  },
  header: {
    width: '100%',
    fontSize: '1rem',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
}), { name: 'program-dashboard-workflow-links' });
